module.exports = __webpack_public_path__ + "static/fipcpinkfloral1-6e6bfd04f46807b65f424c108296f382.jpeg";